import { useEffect, useState } from "react";
import API from "../services/api";

export default function Wishlist({ setCartCount }) {

  const [wishlistItems, setWishlistItems] = useState([]);

  useEffect(() => {
    fetchWishlist();
  }, []);

  const fetchWishlist = async () => {
    try {
      const response = await API.get("/api/wishlist");
      setWishlistItems(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  // Remove from wishlist
  const handleRemove = async (productId) => {
    try {
      await API.post(`/api/wishlist/remove/${productId}`);
      setWishlistItems(prev =>
        prev.filter(item => item.product.id !== productId)
      );
    } catch (error) {
      console.log(error);
    }
  };

  // Move to cart
  const handleMoveToCart = async (productId) => {
    try {
      await API.post(`/api/cart?productId=${productId}&quantity=1`);
      await API.post(`/api/wishlist/remove/${productId}`);

      setWishlistItems(prev =>
        prev.filter(item => item.product.id !== productId)
      );

      const response = await API.get("/api/cart");
      setCartCount(response.data.length);

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={{ background: "#f1f3f6", minHeight: "100vh", marginTop: "20px" }}>
      <div className="container py-4">

        <h4 className="mb-4 fw-bold">My Wishlist ❤️</h4>

        {wishlistItems.length === 0 ? (
          <div className="card p-5 text-center shadow-sm">
            <h5>Your Wishlist is Empty</h5>
            <p className="text-muted">Add items you like ❤️</p>
          </div>
        ) : (

          <div className="row">

            <div className="col-md-8">

              {wishlistItems.map((item) => (
                <div key={item.id} className="card mb-3 p-3 shadow-sm">

                  <div className="row align-items-center">

                    {/* Image */}
                    <div className="col-md-3 text-center">
                      <img
                        src={item.product.imageUrl}
                        alt={item.product.name}
                        className="img-fluid"
                        style={{ height: "120px", objectFit: "cover" }}
                      />
                    </div>

                    {/* Details */}
                    <div className="col-md-6">
                      <h6 className="fw-semibold">{item.product.name}</h6>

                      <p className="text-muted small">
                        {item.product.categories?.name}
                      </p>

                      <h5 className="fw-bold text-success">
                        ₹{item.product.price.toFixed(2)}
                      </h5>

                      <p className="text-success small">
                        Free Delivery
                      </p>
                    </div>

                    {/* Actions */}
                    <div className="col-md-3 text-center">

                      <button
                        className="btn btn-warning w-100 mb-2"
                        onClick={() => handleMoveToCart(item.product.id)}
                      >
                        Move to Cart
                      </button>

                      <button
                        className="btn btn-outline-danger w-100"
                        onClick={() => handleRemove(item.product.id)}
                      >
                        Remove
                      </button>

                    </div>

                  </div>

                </div>
              ))}

            </div>

            {/* Right Section */}
            <div className="col-md-4">
              <div className="card p-3 shadow-sm">

                <h6 className="text-muted border-bottom pb-2">
                  WISHLIST SUMMARY
                </h6>

                <div className="d-flex justify-content-between mt-3">
                  <span>Total Items</span>
                  <span>{wishlistItems.length}</span>
                </div>

                <hr />

                <button className="btn btn-danger w-100">
                  ADD ALL TO CART
                </button>

              </div>
            </div>

          </div>
        )}
      </div>
    </div>
  );
}